var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.breadcrumbs.length
    ? _c(
        "v-container",
        { staticClass: "pa-0", attrs: { fluid: "", "grid-list-lg": "" } },
        [
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  !_vm.dashboard
                    ? _c("v-breadcrumbs", {
                        staticClass: "pb-0",
                        attrs: {
                          divider: "/",
                          items: _vm.breadcrumbs,
                          dark: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "item",
                              fn: function(props) {
                                return [
                                  _c(
                                    "li",
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "grey--text text--lighten-4 v-breadcrumbs__item",
                                          class: [
                                            props.item.disabled &&
                                              "v-breadcrumbs__item--disabled text--lighten-1"
                                          ],
                                          attrs: {
                                            to: props.item.link,
                                            disabled: props.item.disabled
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(props.item.text) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          468225354
                        )
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }